export default "__VITE_ASSET__D91zyxn8__"